<template>
  <div class="w-full">
    <SmartTitle heading="1" weight="medium">Nova Meta Mínima</SmartTitle>
    <SmartCard class="w-full card-one flex justify-between">
      <div>
        <SmartP>Escolher loja</SmartP>
        <p class="ml-2">Defina a loja onde criaremos a meta mínima</p>
      </div>
      <div class="div-aux">
        <VAutocomplete
          :items="userStores"
          placeholder="Selecione o PDV"
          no-data-text="Não há PDV's"
          :disabled="showPdvList"
          item-text="name"
          item-value="id"
          v-model="selectedStore"
          class="nowrap_select"
        >
          <template v-slot:item="{ item, index }">
            <div class="v-list__tile__content">
              <p
                :id="`user-${index}`"
                class="text-overflow-hidden text-overflow-ellipsis"
              >
                {{ item.name }}
              </p>
            </div>
          </template>
        </VAutocomplete>
      </div>
    </SmartCard>
    <div class="mt-4">
      <SmartCard class="head-add flex align-center justify-around">
        <p class="ml-2 no-wrap">Produto</p>
        <p class="no-wrap">Tipo de meta</p>
        <p class="no-wrap">Volume base</p>
        <p class="mr-2 no-wrap">Faturamento base</p>
      </SmartCard>
    </div>
    <div>
      <SmartCard
        v-for="(listProduct, index) in products"
        :key="listProduct.name"
        class="cards flex align-center mt-2 justify-around"
      >
        <div class="field-table-product-info">
          <div style="width: 100%">
            <p class="ml-2">{{ listProduct.name }}</p>
          </div>
        </div>
        <div class="div-aux-three">
          <VSelect
            :disabled="isPdvChecked"
            :items="minimalGoalsTypeGetter"
            placeholder="Automático"
            item-text="name"
            item-value="id"
            v-model="minimal_goal_type_id[index]"
            class="nowrap_select"
          >
            <template v-slot:item="{ item, index }">
              <div class="v-list__tile__content">
                <div :id="`type-${index}`" class="v-list__tile__title">
                  {{ item.name }}
                </div>
              </div>
            </template>
          </VSelect>
        </div>
        <div class="div-aux-two">
          <SmartInputMoney
            :disabled="disableVolume[index]"
            type="volume"
            v-model="volume[index]"
          />
        </div>
        <div class="div-aux-two">
          <SmartInputMoney
            :disabled="disableRevenue[index]"
            type="money"
            v-model="revenues[index]"
          />
        </div>
      </SmartCard>
      <SmartCard v-if="showPdvList">
        <div style="padding: 1rem; display: flex; justify-content: center">
          <p>Nenhum produto para ser exibido</p>
        </div>
      </SmartCard>
      <div class="flex mt-4 justify-end">
        <SmartButton
          :loading="isLoading"
          :disabled="isPdvChecked"
          @click="sendInfo"
          id="submit"
        >
          Salvar
        </SmartButton>
      </div>
      <SmartModal v-if="modal" v-bind="modal" @close="modal = null">
        {{ modal.text }}
      </SmartModal>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

const VOLUME = 2;
const FATURAMENTO = 3;
const VOLUME_FATURAMENTO = 4;

export default {
  name: "FormCreate",
  data() {
    return {
      isLoading: false,
      volume: [],
      revenues: [],
      minimal_goal_type_id: [],
      disableVolume: [],
      disableRevenue: [],
      selectedStore: null,
      inputsTypes: [],
      modal: null,
      productSaved: [],

      header: [
        { text: "Produto", value: "produto" },
        { text: "Tipo de meta", value: "tipo_meta" },
        { text: "Volume base", value: "volume_base" },
        { text: "Faturamento base", value: "faturamento_base" },
      ],
    };
  },
  watch: {
    minimal_goal_type_id() {
      this.minimal_goal_type_id.forEach((item, index) => {
        switch (item) {
          case VOLUME: {
            this.revenues[index] = 0;
            this.disableVolume[index] = false;
            this.disableRevenue[index] = true;
            break;
          }
          case FATURAMENTO: {
            this.volume[index] = 0;
            this.disableVolume[index] = true;
            this.disableRevenue[index] = false;
            break;
          }
          case VOLUME_FATURAMENTO: {
            this.disableVolume[index] = false;
            this.disableRevenue[index] = false;
            break;
          }
          default: {
            this.disableVolume[index] = true;
            this.disableRevenue[index] = true;
            this.volume[index] = 0;
            this.revenues[index] = 0;
            break;
          }
        }
      });
    },
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      userStores: "minimumGoal/userStores",
      products: "goalsDistribuition/getProducts",
      minimalGoalsTypeGetter: "minimumGoal/minimalGoalsTypeGetter",
    }),
    showPdvList() {
      return typeof this.products === "undefined";
    },
    isPdvChecked() {
      if (!this.selectedStore && this.minimal_goal_type_id !== 1) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions({
      fetchUserStores: "minimumGoal/fetchAllUserStores",
      storeInfo: "minimumGoal/storeInfo",
      fetchProducts: "goalsDistribuition/fetchProducts",
      fetchMinimalGoalsType: "minimumGoal/fetchMinimalGoalsType",
    }),
    showSuccessModal() {
      this.modal = {
        type: "success",
        title: "Ok! Tudo certo.",
        icon: "accepted",
        buttonText: "Ok",
        text: "Metas mínimas atualizadas com sucesso!",
        routerRedirect: "MetaMinima",
      };
    },
    showErrorModal() {
      this.modal = {
        type: "warning",
        title: "Ops! Algo deu errado.",
        icon: "alert",
        buttonText: "Ok",
        text: "Não sabemos exatamento o que aconteceu. Verifique se todas as informações estão corretas e tente novamente.",
        routerRedirect: "",
      };
    },
    allProductIsSaved(productSaved) {
      return productSaved.length
        ? productSaved.reduce((allSaved, item) => allSaved && item, true)
        : false;
    },
    sendInfo() {
      const payload = [];
      this.isLoading = true;
      const self = this;
      payload.push({
        active: true,
        place_id: this.selectedStore,
        minimalGoalSegment: [],
      });
      this.products.forEach((item, index) => {
        payload[0].minimalGoalSegment.push({
          segment_id: item.segment_id,
          volume: this.volume[index]
            ? this.volume[index]
                .toString()
                .replace(/\./g, "")
                .replace(/\,/g, ".")
            : 0,
          place_id: this.selectedStore,
          revenues: this.revenues[index]
            ? this.revenues[index]
                .toString()
                .replace(/\./g, "")
                .replace(/\,/g, ".")
            : 0,
          minimal_goal_type_id: this.minimal_goal_type_id[index] || 1,
          active: true,
          goals_type_id: item.goals_type_id,
          additional_goal_id: item.additional_goal_id,
        });
      });
      this.savePayload(self, payload, 0);
    },
    savePayload(self, payload, index) {
      this.storeInfo(payload[index])
        .then(() => {
          self.showSuccessModal();
        })
        .catch(() => {
          this.showErrorModal();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },

  async mounted() {
    this.fetchUserStores(this.user.id);
    await this.fetchProducts();
    this.products.forEach((item, index) => {
      this.productSaved[index] = false;
      if (!this.minimal_goal_type_id[index]) {
        this.disableVolume[index] = true;
        this.disableRevenue[index] = true;
      }
    });
    this.fetchMinimalGoalsType();
  },
};
</script>

<style lang="scss">
.cards {
  display: grid;
  grid-template-columns: repeat(4, 2fr);
  grid-gap: 3rem;
  overflow-x: hidden;
  height: 70px;
  overflow-y: hidden;
}

.card-one {
  height: 76px;
}
.div-aux {
  width: 288px;
  margin-right: 23px;
}

.head-add {
  overflow-x: hidden;
  display: grid;
  grid-template-columns: repeat(4, 2fr);
  grid-gap: 3em;
  height: 50px;
  background: rgba(151, 151, 151, 0.05);
}
.card-two {
  height: 50px;
}
.div-aux-two {
  width: 200px;
}
.div-aux-two input {
  border: 4px solid;
}

input.input-money {
  border: 2px solid !important;
  color: grey !important;
}

.div-aux-three {
  width: 202px;
}
.name {
  width: 100px;
}

.field-table-product-info {
  max-width: 300px;
  display: flex;
  flex-direction: column;
}

@media (max-width: 992px) {
  .field-table-product-info {
    padding-bottom: 1rem;
    display: flex;
    flex-direction: column;
  }
}
</style>
